import React from 'react'

export default function Footer() {
  return (
    <footer>
      © 2021 Ashley Sands
      <a href="https://www.linkedin.com/in/ashley-sands-b64827121/"><img id="linkedin" src="https://i.imgur.com/oxGZLGA.png" alt="linkedin logo" /></a>
      <a href="https://github.com/asands94/wizards"><img id="github" src="https://i.imgur.com/BbYTbcQ.png" alt="github logo" /></a>
    </footer>
  )
}
